import React from 'react';
import PropTypes from 'prop-types';
import IropsItinearyCards from './irops-itinerary-cards';
import TranslatedCopy from '../../intl/translated-copy';
function IropsOntimeCards({
  allDestinationInfo,
  country,
  language,
  pnrModel,
  tripType,
  legs,
}) {
  const trip = tripType;
  const isMulticity = pnrModel?.isMulticity();
  const isRoundTrip = !isMulticity && trip === 'ROUNDTRIP';
  const isOneWay = !isMulticity && trip === 'ONEWAY';

  const onTimeData = legs?.filter((onTime) =>
    onTime?.segmentsCollection?.some((segment) => segment?.flightSegmentType === 'flight-onTime')
  );

  return (
    <>
      <div className='iropsatc-conetnt-header'>
        <TranslatedCopy
          className='iropsatc-header-message'
          copyID='MYB_RESERVATION_FOUND'
          tagName='p'
        />
      </div>
      <div className='itinerary-cards-list'>
        <div className='itinerary-tag-master'>
          <div className='tag-master-container flight-onTime'>
            <TranslatedCopy
              className='iropsatc-tag-message'
              copyID='MYB_ON_TIME'
            />
            <span className='ItineraryCard-status-hour' />
          </div>
        </div>
        { onTimeData?.map((legModel, index) => {
          return (
            <IropsItinearyCards
              allDestinationInfo={ allDestinationInfo }
              country={ country }
              flightTime={ 'flight-onTime' }
              isOneWay={ isOneWay }
              isRoundTrip={ isRoundTrip }
              iteration={ index }
              itineraryPartType={ legModel?.itineraryPartType }
              language={ language }
              legIndex={ index }
              legModel={ legModel }
              tripTag={ 1 }
            />
          );
        }) }
      </div>
      <div className='ontime-space-container' />
    </>
  );
}

IropsOntimeCards.propTypes = {
  allDestinationInfo: PropTypes.object,
  country: PropTypes.string,
  flightStatus: PropTypes.string,
  flightTime: PropTypes.string,
  language: PropTypes.string,
  legs: PropTypes.array,
  pnrModel: PropTypes.object,
  tripType: PropTypes.number,
};

IropsOntimeCards.defaultProps = {
  allDestinationInfo: {},
  country: '',
  flightStatus: '',
  flightTime: '',
  language: '',
  legs: [],
  pnrModel: {},
  tripType: null,
};

export default IropsOntimeCards;